import Images from '../config/Images';
import { supportedLanguages } from './i18n';
import IconImage from '../components/image/IconImage';
import { decryptURL, encryptURL } from './encryptDecryptService';

export const getFromAsync = (key) => JSON.parse(localStorage.getItem(key));
export const removeFromAsync = async (key) => localStorage.removeItem(key);
export const setInAsyncStorage = (key, value) => localStorage.setItem(key, JSON.stringify(value));

export const getUrlParams = ({ data }) => decryptURL(data);
export const generateUrl = (path, data) => path + '/' + encryptURL(data);

export const generateLocalizedPath = (lang, route) => {
  const defaultLang = 'en';
  const supportedLang = supportedLanguages?.includes(lang) ? lang : defaultLang;
  return `/${supportedLang}/${route || ''}`;
};

export const getEncodedLastSegmentFromURL = (url) => {
  try {
    const pathSegments = url.split('/').filter(Boolean);
    const encodedString = pathSegments[pathSegments.length - 1];
    return encodedString || null;
  } catch (error) {
    console.error('Error extracting encoded string from resolvedPath:', error);
    return null;
  }
};

export const DownArrowIcon = () => (
  <div>
    <IconImage name={Images.Polygon} isEye width={15} height={15} />
  </div>
);
